import { showHideChildrenByNames } from "../helpers";

/**
 * Переключает видимость дочернего объекта по имени
 * @param {string} name - имя дочернего объекта
 * @param {boolean} visible - true = показать, false = скрыть
 * @param {object} obj - родительский объект, у которого переключаем дочерний объект (по дефолту это servObj.redactorModeObject)
 */
export const toggleChildByName = (name, visible, obj = servObj.redactorModeObject) => {
    if (!obj.userData.visibleChildren) {
        obj.userData.visibleChildren = [];
    }
    const filterFn = (el) => !el.includes(name);
    // Удаляем, чтобы избежать дублей
    obj.userData.visibleChildren = obj.userData.visibleChildren.filter(filterFn);
    if (visible) {
        obj.userData.visibleChildren.push(name);
    }
    // Переключаем в сцене
    showHideChildrenByNames(obj, [name], visible);
};
